export enum EMixpanelEvents {
  Lead = 'Supplier Lead',
  UserCreated = 'Supplier User Created',
  SubmitToReview = 'Supplier Submit To Review',
  ViewPage = 'View Page',
  ViewWindow = 'View window',
}

export enum EMixpanelDataKeys {
  DistinctId = '$distinct_id',
  Email = '$email',
  Name = '$name',
  Phone = '$phone',
  AuthenticationMethod = 'supplier_authentication_method',
  ProductsSource = 'supplier_products_source',
  Skus = 'supplier_skus',
  ProcessingTime = 'supplier_proccessing_time',
  StoreCategory = 'supplier_store_category',
  PagePath = 'Page Path',
  WindowType = 'Window Type',
  WindowName = 'Window Name',
}
